import { css } from "@linaria/core";
import { styled } from "@linaria/react";
export const cssIsZoomed = "cssIsZoomed_cg6hrka";
export const StyledOriginalImage = /*#__PURE__*/styled('div')({
  name: "StyledOriginalImage",
  class: "StyledOriginalImage_s8yn1h6"
});
export const StyledZoomContainer = /*#__PURE__*/styled('figure')({
  name: "StyledZoomContainer",
  class: "StyledZoomContainer_s4pxg59"
});

require("./StyledZoomImage.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledZoomImage.tsx");